<template>
	<div class="tem-box clearfix">
		<!--
      多个文件的上传
		-->
		<div class="img-list" v-for="item of fileInfoList" :key="item.attachUrl">
			<div class="img-box">
				<img v-if="item.attachType=='image'" :src="item.attachUrl" />
				<el-button icon="el-icon-delete" class="del" size="small" @click="handleRemove(item.attachUrl)"></el-button>
			</div>
		</div>
		<el-upload v-if="fileInfoList.length<limit" class="all-upload" name="file" :action="action" :show-file-list="false" :limit="limit" :data="qnData" :on-error="handleError" :on-success="handleSucces" :before-upload="handleBefore" :accept="acceptType">
			<!-- 上传按钮 -->
			<el-button class="up-but" icon="el-icon-plus"></el-button>
		</el-upload>
		<div v-if="fileInfoList.length<limit" class="desc">请上传后缀名为:{{typeString}}的文件。</div>
	</div>
</template>

<script>
import { conf } from "@/config";
import { getData } from "@/http/fetch.js";
import { getMediaType } from "@/utils/index.js";
export default {
	props: {
		typeList: {
			type: Array,
			default: () => {} //  typeList: ["image", "audio"],
		},
		// {
		//   attachSize: "13147",
		//   attachType: "image",
		//   attachUrl: "http://h.xueduoduo.com.cn/1622617444704.jpg",
		// },
		fileInfoList: {
			type: Array,
			default: () => []
		},
		fileLimit: "", //限制大小
		limit: {
			//限制上传个数
			required: false,
			type: Number,
			default: 1
		}
	},
	data() {
		return {
			qnData: {
				// token: "",
				// key: "",
			},
			domainUrl: "",
			// limit: 1, //限制上传个数
			allTypeList: [
				{ name: "image", type: ["png", "jpeg", "jpg"] },
				{ name: "audio", type: ["mp3"] },
				{ name: "video", type: ["mp4"] }
			],
			typeString: ""
		};
	},
	computed: {
		acceptType() {
			return this.typeString;
		},
		action() {
			return conf.uploadAction;
		}
	},
	created() {
		let allowType = this.allTypeList.filter(
			item => this.typeList.indexOf(item.name) != -1
		);
		this.typeString = "";
		allowType.forEach(item => {
			item.type.forEach(item1 => {
				this.typeString = this.typeString + "." + item1 + ",";
			});
		});
	},

	methods: {
		handleBefore(file) {
			//后缀名类型判断
			let filetype = getMediaType(file.name);
			if (this.typeList.indexOf(filetype) == -1) {
				this.$message({
					type: "warning",
					message: "请上传后缀名为" + this.typeString + "的附件！"
				});
				return false;
			}
			//文件大小判断
			if (file.size / 1024 / 1024 > this.fileLimit) {
				this.$message.error("上传文件大小必须小于" + this.fileLimit + "MB");
				return false;
			}
			//获取token，文件上传
			return getData("/file/getQiNiuAccessToken")
				.then(res => {
					console.log("--res", res);
					this.domainUrl = res.domainUrl;
					this.qnData.token = res.accessToken;
					this.qnData.key =
						new Date().getTime() +
						"." +
						file.name.split(".")[file.name.split(".").length - 1]; // 处理上传同名文件失败加上时间戳
				})
				.catch(err => {
					this.$message({ type: "error", message: err });
				});
		},
		//上传成功
		async handleSucces(response, file, fileList) {
			let data = {
				attachName: file.name,
				attachSize: parseFloat(file.size / 1024).toFixed(0),
				attachType: getMediaType(file.name),
				attachUrl: this.domainUrl + file.response.key
			};
			//新增上传的
			this.fileInfoList.push(data);
		},
		//失败
		handleError() {
			this.$message.warning("上传失败请稍后重试！");
		},
		// 移除按钮
		handleRemove(url) {
			let newValue = this.fileInfoList.filter(item => item.attachUrl != url);
			this.$emit("uploadFile", newValue);
		}
	},
	watch: {
		fileInfoList: {
			handler(newValue, oldVal) {
				this.$emit("uploadFile", newValue);
			},
			deep: true
		}
	}
};
</script>

<style lang="less" scoped>
.tem-box {
	// border: 1px solid rgb(17, 190, 69);
	.img-list {
		box-sizing: border-box;
		float: left;
		// border: 1px solid rgb(241, 43, 43);
		margin-right: 10px;
		margin-bottom: 10px;
		.img-box {
			img {
				height: 110px;
				width: 160px;
				vertical-align: top;
				border: 1px solid #c0ccda;
				border-radius: 6px;
			}
			.del {
				padding: 8px;
			}
		}
	}

	.all-upload {
		float: left;
		margin-right: 10px;
		margin-bottom: 10px;
		.up-but {
			height: 110px;
			width: 160px;
			background-color: #fbfdff;
			border: 1px dashed #c0ccda;
			border-radius: 6px;
			/deep/.el-icon-plus {
				font-size: 28px;
				color: #8c939d;
			}
		}
		.up-but:hover {
			border: 1px dashed @color;
		}
	}
	.desc {
		float: left;
		color: @hui;
		font-size: 13px;
		line-height: 13px;
		margin-top: 85px;
	}
}
</style>
